import { Search } from "lucide-react";
import React from "react";

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  minChars?: number;
  className?: string;
  inputClassName?: string;
}

export function SearchInput({
  value,
  onChange,
  placeholder = "Search...",
  minChars = 3,
  className,
  inputClassName
}: SearchInputProps) {
  const [focused, setFocused] = React.useState(false);

  return (
    <div className={`relative flex flex-col gap-1 ${className ?? ""}`}>
      <Search className="absolute left-3 top-2.5 text-gray-400 w-5 h-5" />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        placeholder={placeholder}
        className={`w-full !pl-10 pr-4 !py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent ${inputClassName ?? ""}`}
        aria-label={placeholder}
      />
      {focused && value.length < minChars && (
        <span className="text-[10px] text-gray-400">Type at least {minChars} characters to search</span>
      )}
    </div>
  );
}

export default SearchInput;
